import { render, staticRenderFns } from "./DeleteActivity.vue?vue&type=template&id=5b77745d&"
import script from "./DeleteActivity.vue?vue&type=script&lang=js&"
export * from "./DeleteActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports